var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    [
      _c(
        "v-tabs",
        {
          attrs: { "background-color": "blue-grey lighten-5" },
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        },
        [
          _c("v-tab", { key: "se_sky_race" }, [_vm._v("Sky Race")]),
          _c("v-tab", { key: "se_sky_race_common" }, [
            _vm._v("Sky Race Common"),
          ]),
          _c("v-tab", { key: "se_challenge" }, [_vm._v("Challenge")]),
          _c("v-tab", { key: "se_lboard" }, [_vm._v("Leaderboard")]),
        ],
        1
      ),
      _c(
        "v-tabs-items",
        {
          staticClass: "mt-4",
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        },
        [
          _c(
            "v-tab-item",
            { key: "se_sky_race" },
            [_c("r-sky-sprint-config-page")],
            1
          ),
          _c(
            "v-tab-item",
            { key: "se_sky_race_common" },
            [_c("r-sky-common-config-page")],
            1
          ),
          _c(
            "v-tab-item",
            { key: "se_challenge" },
            [_c("r-challenge-config-page")],
            1
          ),
          _c(
            "v-tab-item",
            { key: "se_lboard" },
            [_c("r-league-config-page")],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }